<template>
    <div>
        <config-main-title v-if="!is_contabil">
            Layout de Exportações
        </config-main-title>

        <div class="row mb-3">
            <div class="col col-12 col-md-6 d-flex flex-column">
                <az-input icon="fas fa-search" v-model="search" />
            </div>
            <div class="col col-12 col-md-3 d-flex flex-column">
                <div class="btn-group mb-1" role="group" aria-label="Basic example">
                    <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                    @click="viewMode = 'A'">
                        Ativos
                    </button>
                    <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                    @click="viewMode = 'T'">
                        Todos
                    </button>
                </div>
            </div>
            <div class="col col-12 col-md-3 d-flex flex-column">
                <button type="button" class="btn btn-outline-success" @click="incluir ()">
                    Incluir Layout
                </button>
            </div>
        </div>

        <az-empty-state v-if="!dados || !dados.length" />

        <div v-else>

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                    </span>
                </li>
            </div>

        </div>

        <az-wiki topic="Layout_de_Exportação" />

        <!-- Modal -->
        <div class="modal fade" id="edicaoLayoutModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable modal-dialog2" role="document">
                <div class="modal-content" v-if="edicao">
                    <div class="modal-header">
                        <h5 class="modal-title">Layout Exportação</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    placeholder="Título..."
                                    label="Título"
                                    required
                                    :validate="validate"
                                    v-model="edicao.st_titulo" />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                    type="select"
                                    placeholder="Tipo..."
                                    label="Tipo"
                                    optionsData="id"
                                    optionsDisplay="search"
                                    required
                                    :optionsList="models"
                                    :validate="validate"
                                    v-model="edicao.st_model_type" />
                            </div>
                            <div class="col col12 col-md-3">
                                <az-input
                                    type="select"
                                    placeholder="Tipo do arquivo..."
                                    label="Tipo do arquivo"
                                    optionsDisplay="search"
                                    required
                                    :optionsList="[
                                        {id: '0', search: 'CSV'}, 
                                        {id: '1', search: 'Pipe'},
                                    ]" 
                                    optionsData="id" 
                                    :validate="validate"
                                    v-model="edicao.ch_tipo" />

                                <!-- {id: '2', search: 'Posicional'} -->
                            </div>
                        </div>

                        <ul class="nav nav-tabs mt-3" id="myTab" role="tablist">
                            <li class="nav-item" role="presentation">
                                <a class="nav-link active" id="campos-tab" data-toggle="tab" href="#campos" role="tab" aria-controls="campos" aria-selected="true">Campos</a>
                            </li>
                            <li class="nav-item" role="presentation">
                               <a class="nav-link" id="filtros-tab" data-toggle="tab" href="#filtros" role="tab" aria-controls="filtros" aria-selected="false">Filtro</a>
                            </li>
                        </ul>

                        <div class="tab-content" id="myTabContent">

                            <!-- CAMPOS -->
                            <div class="tab-pane fade show active" id="campos" role="tabpanel" aria-labelledby="campos-tab">

                                <draggable v-model="edicao.st_campos_json" @start="drag=true" @end="drag=false;" ghost-class="primary" draggable=".form-row">

                                    <div class="form-row" v-for="(campo, icx) in edicao.st_campos_json" :key="icx">
                                        <div class="col col-12 col-md-1" v-if="edicao.ch_tipo == 2">
                                            <az-input
                                                type="select"
                                                sizing="sm"
                                                :label="icx ? '' : 'Tipo'"
                                                :optionsList="[
                                                    { id: 'C', search: 'Cabeçalho' },
                                                    { id: 'Q', search: 'Quebra' }, 
                                                    { id: 'P', search: 'Quebrar Por' }, 
                                                    { id: 'L', search: 'Linha' }, 
                                                ]"
                                                optionsData="id"
                                                :validate="validate"
                                                v-model="campo.posicao">
                                            </az-input>
                                        </div>
                                        <div class="col col-12" :class="edicao.ch_tipo == 2 ? 'col-md-4' : 'col-md-6'">
                                            <az-input
                                                sizing="sm"
                                                type="select"
                                                :optionsList="lista_campos"
                                                optionsDisplay="search"
                                                :label="icx ? '' : 'Campo'"
                                                required
                                                :validate="validate"
                                                v-model="campo.campo">
                                                <template v-slot:button-pre>
                                                    <div class="input-group-prepend">
                                                        <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="remover_campo(icx)">
                                                            <i class="fa fa-minus" aria-hidden="true"></i>
                                                        </button>
                                                    </div>
                                                </template>
                                            </az-input>
                                        </div>
                                        <template  v-if="campo.campo && ( campo.campo.id == 'fixo' || campo.campo.id == 'formula' )">
                                            <div class="col col-12" :class="edicao.ch_tipo == 2 ? 'col-md-2' : 'col-md-3'">
                                                <az-input
                                                    placeholder="Título..."
                                                    sizing="sm"
                                                    :label="icx ? '' : 'Titulo'"
                                                    :validate="validate"
                                                    v-model="campo.titulo">
                                                </az-input>
                                            </div>
                                            <div class="col col-12" :class="edicao.ch_tipo == 2 ? 'col-md-2' : 'col-md-3'">
                                                <az-input
                                                    sizing="sm"
                                                    placeholder="Valor..."
                                                    :label="icx ? '' : 'Valor'"
                                                    :validate="validate"
                                                    v-model="campo.valor">
                                                </az-input>
                                            </div>
                                        </template>
                                        <div class="col col-12" :class="edicao.ch_tipo == 2 ? 'col-md-4' : 'col-md-6'" v-else>
                                            <az-input
                                                placeholder="Título..." 
                                                sizing="sm"
                                                :label="icx ? '' : 'Titulo'"
                                                :validate="validate"
                                                v-model="campo.titulo">
                                            </az-input>
                                        </div>

                                        <template v-if="edicao.ch_tipo == 2">
                                            <div class="col col-12 col-md-1">
                                                <az-input
                                                    type="number"
                                                    sizing="sm"
                                                    :label="icx ? '' : 'Tamanho'"
                                                    :validate="validate"
                                                    v-model="campo.tamanho">
                                                </az-input>
                                            </div>
                                            <div class="col col-12 col-md-1">
                                                <az-input
                                                    type="select"
                                                    sizing="sm"
                                                    :label="icx ? '' : 'Tipo'"
                                                    :optionsList="[
                                                        { id: 'T', search: 'Texto' },
                                                        { id: 'I', search: 'Inteiro' }, 
                                                        { id: 'M', search: 'Moeda' }, 
                                                        { id: 'D', search: 'Data' }
                                                    ]"
                                                    optionsData="id"
                                                    :validate="validate"
                                                    v-model="campo.tipo">
                                                </az-input>
                                            </div>
                                            <div class="col col-12 col-md-1">
                                                <az-input
                                                    type="select"
                                                    sizing="sm"
                                                    :label="icx ? '' : 'Formato'"
                                                    :optionsList="[
                                                        { id: 'S', search: 'Sem separador' },
                                                        { id: 'V', search: 'Vírgula' }, 
                                                        { id: 'P', search: 'Ponto' }, 
                                                    ]"
                                                    v-if="campo.tipo == 'M'"
                                                    :validate="validate"
                                                    v-model="campo.formato">
                                                </az-input>
                                                <az-input
                                                    placeholder="dd/mm/aaaa"
                                                    sizing="sm"
                                                    :label="icx ? '' : 'Formato'"
                                                    v-else-if="campo.tipo == 'D'"
                                                    :validate="validate"
                                                    v-model="campo.formato">
                                                </az-input>
                                            </div>

                                        </template>
                                    </div>

                                </draggable>

                                <button type="button" class="btn btn-primary mt-3" @click="incluir_campo()">
                                    <i class="fa fa-plus" aria-hidden="true"></i>
                                </button>
                            </div>

                            <!-- FILTROS -->
                            <div class="tab-pane fade" id="filtros" role="tabpanel" aria-labelledby="filtros-tab">

                                <div class="form-row" v-for="(filtro, icx) in edicao.st_filtros_json" :key="icx">
                                    <div class="col col-12 col-md-3">
                                        <az-input
                                            sizing="md"
                                            type="select"
                                            :optionsList="lista_filtros"
                                            optionsDisplay="search"
                                            :label="icx ? '' : 'Campo'"
                                            required
                                            :validate="validate"
                                            v-model="filtro.campo">
                                            <template v-slot:button-pre>
                                                <div class="input-group-prepend">
                                                    <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="remover_filtro(icx)">
                                                        <i class="fa fa-minus" aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                    <div class="col col12 col-md-2">
                                    <az-input
                                        type="select"
                                        sizing="md"
                                        placeholder="Tipo do filtro..."
                                        :label="icx ? '' : 'Tipo do filtro'"
                                        optionsDisplay="search"
                                        :optionsList="[{id: '0', search: 'Fixo'}, {id: '1', search: 'Variável'}]" 
                                        optionsData="id" 
                                        :validate="validate"
                                        v-model="filtro.tipo" />
                                    </div>
                                    <div class="col col12 col-md-2">
                                    <az-input
                                        type="select"
                                        sizing="md"
                                        placeholder="Operação..."
                                        :label="icx ? '' : 'Operação'"
                                        optionsDisplay="search"
                                        :optionsList="getOperacoes(filtro.campo)" 
                                        optionsData="id" 
                                        :validate="validate"
                                        v-model="filtro.operacao" />
                                    </div>
                                    <div class="col col-12 col-md-5">
                                        <template v-if="filtro.campo && filtro.campo.format && filtro.campo.format == 'dthr' && filtro.operacao && filtro.operacao == 'periodo' ">
                                            <az-periodo v-model="filtro.valorPeriodo" :class="icx ? '' : 'mt-4'" />
                                        </template>

                                        <template v-else>
                                            <az-input
                                                sizing="md"
                                                :type="(filtro.campo && filtro.campo.format && filtro.campo.format == 'currency') ? 'money' : ''"
                                                :label="icx ? '' : 'Valor do filtro'"
                                                :validate="validate"
                                                :edicao="filtro.tipo == '0'"
                                                v-model="filtro.valor">
                                            </az-input>
                                        </template>
                                    </div>
                                </div>

                                <button type="button" class="btn btn-primary mt-3" @click="incluir_filtro()">
                                    <i class="fa fa-plus" aria-hidden="true"></i>
                                </button>                            
                            </div>

                        </div>
                        
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar()">{{ edicao.id_exportacao_layout ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import AzWiki from '../../util/AzWiki.vue';
import draggable from "vuedraggable";
// import AzSubTitle from '../../util/AzSubTitle.vue';

export default {
    data() { 
        return { 
            dados: null,
            breadcrumb: null, 
            search: "", 
            viewMode: "A",
            edicao: null, 
            validate: false, 
            models: [],
            novo_campo: "",
            drag: false, 
        };
    },

    components: { 
        ConfigMainTitle,
        AzEmptyState,
        AzInput,
        AzSubmit,  
        AzPeriodo, 
        AzWiki, 
        draggable, 
    },

    computed: { 
        is_contabil: function () { 
            return this.$route.path.slice(0,14) == '/contabilidade';
        },

        lista: function() { 
            if ( !this.dados )
                return [];

            let reg = this.$util.getregex(this.search);

            return this.dados.filter(item => !this.search || reg.test(JSON.stringify(item)));
        },

        lista_campos: function() { 
            if ( !this.edicao || !this.edicao.st_model_type )
                return [];

            let model = this.models.find(item => item.id == this.edicao.st_model_type);

            return ( model && model.campos ) ? model.campos : [];
        },

        lista_filtros: function() { 
            if ( !this.edicao || !this.edicao.st_model_type )
                return [];

            let model = this.models.find(item => item.id == this.edicao.st_model_type);

            return ( model && model.campos ) ? model.campos.filter(item => item.id != 'fixo') : [];
        }
    },

    methods: { 
        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'exportacao_layouts',
                dados: item,
            });

        },

        editar (item) { 
            this.validate = false;
            this.novo_campo = "";
            this.edicao = _.cloneDeep(item);

            if(!this.edicao.st_campos_json) this.edicao.st_campos_json = [];
            if(!this.edicao.st_filtros_json) this.edicao.st_filtros_json = [];

            $('#edicaoLayoutModal').modal('show');
        },

        load() { 
            this.$util.load(this, { 
                service: 'exportacao_layouts',
                parms: { 
                    cadastro: true, 
                },
            });
        },

        incluir_campo() { 
            this.edicao.st_campos_json.push({
                titulo: "", 
            });
        },  

        remover_campo(index) { 
            this.edicao.st_campos_json.splice(index, 1);
        },

        incluir_filtro() { 
            this.edicao.st_filtros_json.push({
                tipo: '0',
                operacao: '=',
                valorPeriodo: {
                  inicio: "",
                  fim: "", 
                  periodo: "do",                   
                }
            });
        },  

        remover_filtro(index) { 
            this.edicao.st_filtros_json.splice(index, 1);
        },

        incluir() { 
            this.validate = false;
            this.novo_campo = "";

            this.edicao = { 
                id_exportacao_layout: null, 
                st_titulo: "",
                ch_tipo: "0", 
                st_model_type: 'App\\azure\\baixa',
                st_campos_json: [], 
                st_filtros_json: [], 
                fl_ativo: true, 
            };

            $('#edicaoLayoutModal').modal('show');
        },

        atualizar() { 
            this.$util.atualizar(this, { 
                service: 'exportacao_layouts',
                dados: this.edicao,
                modal: 'edicaoLayoutModal',
                reload: true, 
            });
        },

        getOperacoes(campo) {
            let optionList = []; 

            if(campo && campo.format == 'dthr' ) {
                optionList = [{id: 'periodo', search: 'Período'}];
            } else {
                optionList = [
                    {id: '=', search: 'Igual (=)'}, 
                    {id: '>=', search: 'Maior ou igual (>=)'},
                    {id: '<=', search: 'Menor ou igual (<=)'},
                    {id: '!=', search: 'Diferente (!=)'},
                ]; 

                if(campo && campo.format != 'currency' ) {
                    optionList.push({id: 'like', search: 'Contém informação'});
                }

            }

            return optionList;
        }

    },

    mounted() { 

        if ( this.is_contabil ) { 
            this.breadcrumb = [
                { name: "Contabilidade", path: "/contabilidade/planos"},
                { name: "Layout de Exportações" },
            ];    
        } else { 
            this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Layout de Exportações" },
            ];
        }

        this.$store.commit('setBreadcrumb', this.breadcrumb);

        this.$util.loadItem(this, { 
            service: 'exportacoes',
            func: 'models',
        })
        .then(res => { 
            this.models = res;
        });

        this.load();

    }
}
</script>

<style scoped>
.modal-dialog2 {
  width: 98% !important;
  min-height: 98% !important;
  padding: 0 !important;
  max-width: 100%;
}
</style>
